/* eslint-disable react/prop-types */
/* eslint-disable react/function-component-definition */
/**
=========================================================
* Material Dashboard 2 React - v2.1.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-dashboard-react
* Copyright 2022 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

import { Link, useLocation, useNavigate } from "react-router-dom";

// Material Dashboard 2 React components
import Icon from "@mui/material/Icon";
import customAlert from "components/MDAlert/customAlert";
import MDBox from "components/MDBox";
import MDSwitch from "components/MDSwitch";
import MDTypography from "components/MDTypography";
import { PreserveTable, useCache } from "context";
import * as React from "react";
import { useContext, useEffect, useState } from "react";
import StatusesService from "services/status-service";
import authPermission from "utility/auth-permissions";

export default function data(props) {
  const { hasPermission } = authPermission();
  const pagePermission = hasPermission("/manage-statuses");
  const preserveTable = useContext(PreserveTable);
  const { page_no, page_size, sort_column, sort_column_value, search_value } =
    preserveTable?.status;
  const { openAlertSB, closeAlertSB, renderAlertSB } = customAlert();
  const [statusesData, setStatusesData] = useState([]);
  const navigate = useNavigate();
  const [open, setOpen] = useState(false);
  const [selectedId, setSelectedId] = React.useState("");
  const [totalData, setTotalData] = useState(0);
  const { cacheItems, setCacheItems } = useCache();
  const [isData, setIsData] = useState(false);
  const location = useLocation();

  const handleClickOpen = (id) => {
    setSelectedId(id);
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  useEffect(() => {
    if (location?.state?.color) {
      openAlertSB(location?.state);
      setTimeout(function () {
        closeAlertSB();
      }, 3000);
    }
    // const getStatusesData = async (e) => {
    //   const response = await StatusesService.getStatuses(page_no, page_size, sort_column, sort_column_value, search_value);
    //   setStatusesData(response?.data);
    //   setTotalData(response?.total);
    // };
    // getStatusesData();
  }, []);

  const getData = async (page_no, page_size, sortColumn, sortColumnValue, searchWord) => {
    const preserveData = {
      page_no,
      page_size,
      sort_column: sortColumn,
      sort_column_value: sortColumnValue,
      search_value: searchWord,
    };
    preserveTable.setPreserveStatus(preserveData);
    const response = await StatusesService.getStatuses(
      page_no,
      page_size,
      sortColumn,
      sortColumnValue,
      searchWord
    );
    setStatusesData(response?.data);
    setTotalData(response?.total);
    setIsData(true);
  };

  const updateStatus = async (id, status) => {
    try {
      const data = { active: status };
      const res = await StatusesService.updateActiveStatus(id, data);
      if (res) {
        if (cacheItems.hasOwnProperty("statuses")) {
          // Create a new object without the key
          const { statuses, ...rest } = cacheItems; // Destructure to exclude key
          setCacheItems(rest); // Set the new cache items without key
        }
        openAlertSB({ color: "success", icon: "check", msg: res, title: "Status" });
        setTimeout(function () {
          closeAlertSB();
        }, 3000);
        const response = await StatusesService.getStatuses(
          page_no,
          page_size,
          sort_column,
          sort_column_value,
          search_value
        );
        setStatusesData(response?.data);
        setTotalData(response?.total);
      }
    } catch (res) {
      if (res.hasOwnProperty("message")) {
        openAlertSB({ color: "error", icon: "warning", msg: res.message, title: "Status" });
        setTimeout(function () {
          closeAlertSB();
        }, 4000);
      } else {
        openAlertSB({
          color: "error",
          icon: "warning",
          msg: res.errors[0].detail,
          title: "Status",
        });
        setTimeout(function () {
          closeAlertSB();
        }, 4000);
      }
    }
  };

  const deleteStatus = async (id) => {
    try {
      const response = await StatusesService.deleteStatus(id);
      if (response) {
        if (cacheItems.hasOwnProperty("statuses")) {
          // Create a new object without the key
          const { statuses, ...rest } = cacheItems; // Destructure to exclude key
          setCacheItems(rest); // Set the new cache items without key
        }
        openAlertSB({ color: "success", icon: "check", msg: response, title: "Status" });
        setTimeout(function () {
          closeAlertSB();
        }, 4000);
      }
    } catch (res) {
      if (res.hasOwnProperty("message")) {
        openAlertSB({ color: "error", icon: "warning", msg: res.message, title: "Status" });
        setTimeout(function () {
          closeAlertSB();
        }, 4000);
      } else {
        openAlertSB({
          color: "error",
          icon: "warning",
          msg: res.errors[0].detail,
          title: "Status",
        });
        setTimeout(function () {
          closeAlertSB();
        }, 4000);
      }
    }
    const res = await StatusesService.getStatuses(
      page_no,
      page_size,
      sort_column,
      sort_column_value,
      search_value
    );
    setStatusesData(res?.data);
    setTotalData(res?.total);
    setSelectedId("");
    handleClose();
  };

  const allRows = [];
  statusesData?.map((eachStatus, index) => {
    const eachData = {
      id: (
        <MDTypography
          component={Link}
          to={pagePermission.edit ? `/manage-statuses/edit?id=${eachStatus.id}` : ""}
          variant="body2"
          color="text"
        >
          {eachStatus.id}
        </MDTypography>
      ),
      name: (
        <MDTypography display="block" variant="body2">
          {eachStatus.name}
        </MDTypography>
      ),
      action: (
        <MDBox display="flex">
          {pagePermission.status ? (
            <MDSwitch
              checked={!!eachStatus.active}
              color="info"
              title="Active Status"
              onChange={() => updateStatus(eachStatus.id, !eachStatus.active)}
            />
          ) : (
            ""
          )}
          {pagePermission.edit ? (
            <MDTypography
              mr={1}
              mt={1}
              component={Link}
              to={`/manage-statuses/edit?id=${eachStatus.id}`}
              title="Edit"
              display="block"
              variant="body2"
              color="info"
            >
              <Icon fontSize="small">edit</Icon>
            </MDTypography>
          ) : (
            ""
          )}
          {pagePermission.new ? (
            <MDTypography
              mr={1}
              mt={1}
              component={Link}
              to={`/manage-statuses/add?id=${eachStatus.id}`}
              title="Copy"
              display="block"
              variant="caption"
              color="secondary"
              fontWeight="medium"
            >
              <Icon fontSize="small">content_copy_icon</Icon>
            </MDTypography>
          ) : (
            ""
          )}
          {pagePermission.remove ? (
            <MDTypography
              mt={1}
              component={Link}
              onClick={() => handleClickOpen(eachStatus.id)}
              title="Remove"
              display="block"
              variant="body2"
              color="error"
            >
              <Icon fontSize="small">delete</Icon>
            </MDTypography>
          ) : (
            ""
          )}
          {renderAlertSB}
        </MDBox>
      ),
    };
    allRows[index] = eachData;
  });

  return {
    columns: [
      { Header: "Id", accessor: "id", width: "10%", align: "left" },
      { Header: "Name", accessor: "name", width: "70%", align: "left" },
      ...(pagePermission.status || pagePermission.edit || pagePermission.remove
        ? [{ Header: "actions", accessor: "action", width: "20%", align: "center" }]
        : []),
    ],
    rows: allRows,
    open,
    handleClickOpen,
    handleClose,
    deleteStatus,
    selectedId,
    totalData,
    page: page_no,
    pageSize: page_size,
    getData,
    sortColumn: sort_column,
    sortColumnValue: sort_column_value,
    searchValue: search_value,
    pagePermission,
    isData: isData,
  };
}
